import { createSelector } from "@reduxjs/toolkit";

import { AppState } from "@store";
import { AbTestVariant, getVariantFromUrl } from "@lib/abTest";

export const abVariantSelector = createSelector<AppState, string, AbTestVariant>(
  (state) => state.router.location.search,
  (queryString) => getVariantFromUrl(queryString)
);
